import axios from 'axios'
import QueryParamsUtil from 'api/utils/query-params-util'

const API_PATH = 'api/v2/admins/revenues'

const RevenuesApiV2 = {

  /**
   * Get list of Seller revenues
   * Invoke `GET api/v2/admins/sellers/revenues
   * @param {object} tableState - ReactTable final state
   * @param {object} additionalFilters - A plain object to get customize filters outside `tableState`
   */
  getRevenues: async ({ tableState, additionalFilters }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = API_PATH

    const response = axios.get(path, { params })
    return response
  },

  /**
   * Get list of Seller revenues
   * Invoke `GET api/v2/admins/sellers/revenues
   * @param {string} date_from - Beginning date of the selected month
   * @param {string} date_to - End date of the selected month
   */
  getRevenuesWithoutPagination: async (date_from, date_to) => {
    // const params = QueryParamsUtil.format(tableState, dateFilters)
    const path   = API_PATH
    const params = {
      date_from : date_from,
      date_to   : date_to
    }

    const response = axios.get(path, { params })
    return response
  },

  /**
   * Download transfer data revenues
   * Invoke `POST api/v2/admins/sellers/revenues/csv`
   * @param {string} date_from - Beginning date of the selected month
   * @param {string} date_to - End date of the selected month
   * @param {number} totalCount - Total count of the revenue data
   * @param {string} owner - Owner of the revenue model
  */
  downloadTransferData: async (dateFrom, dateTo, totalCount, owner) => {
    const path = `${API_PATH}/csv`
    const body = {
      date_from   : dateFrom,
      date_to     : dateTo,
      total_count : totalCount,
      owner       : owner
    }

    const response = axios.post(path, body)
    return response
  },

  /**
   * Create merchant endpoint.
   * Invoke `PATCH api/v2/admins/revenues/:id/transfer`
   * @param {object} values - value of params
   * @params {string} id - id of seller revenue
  */
  patchTransferRevenue: async ({ id, values }) => {
    const path = `${API_PATH}/${id}/transfer`

    const response = await axios.patch(path, values)
    return response
  }

}

export default RevenuesApiV2